import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  params: {},
  actionsloading: false
});

export function emergencybroadcastReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_EMERGENCY_BROADCASTS:
    case actionTypes.SAVE_EMERGENCY_BROADCAST:
    case actionTypes.UPDATE_EMERGENCY_BROADCAST:
      return {
        ...state,
        actionsloading: true
      }
    case actionTypes.FETCH_EMERGENCY_BROADCASTS_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        actionsloading: false
      }
    case actionTypes.SAVE_EMERGENCY_BROADCAST_SUCCESS:
    case actionTypes.UPDATE_EMERGENCY_BROADCAST_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.emergencybroadcastUid]: action.payload
        },
        actionsloading: false
      }
    default:
      return state;
  }
}